import ClearIcon from '@mui/icons-material/Clear'
import { Box, IconButton, Typography } from '@mui/material'
import DisplayPrice from 'components/Common/DisplayValues/DisplayPrice'
import VehicleDisplayName from 'components/Common/VehicleDisplayName/VehicleDisplayName'
import format from 'date-fns/format'
import useClient from 'hooks/useClient'

type HeaderProps = {
  setIsReallocateModalOpen: (e: boolean) => void
  selectedJob: any
}

type DetailProps = {
  text: string
  showBorder?: boolean
}

const Detail = ({ text, showBorder = false }: DetailProps) => {
  return (
    <Typography
      component="p"
      sx={(theme) => ({
        color: theme.palette.common.white,
        borderRight: showBorder ? 3 : 0,
        borderColor: theme.palette.primary.main,
        padding: '0 10px',
      })}
    >
      {text}
    </Typography>
  )
}

const Header = ({ setIsReallocateModalOpen, selectedJob }: HeaderProps) => {
  const getEstimatedArrivalTime = (time: any) => {
    let estimatedArrivalTime = 'N/A'

    if (time) {
      const est = new Date()
      est.setSeconds(est.getSeconds() + time)

      estimatedArrivalTime = format(est, 'HH:mm')
    }

    return estimatedArrivalTime
  }
  const { fixedPriceDisplay, displayVATPrice } = useClient(
    selectedJob.client.clientId,
  )

  console.log('REallocate Header: ', selectedJob)
  return (
    <Box
      component="div"
      sx={(theme) => ({
        width: '100%',
        backgroundColor: theme.palette.brand.main,
        color: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        justifyContent: 'center',
        alignItems: 'center',
        padding: ' 20px 0',
      })}
    >
      <Box
        component="div"
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          id="reallocate-modal-title"
          variant="h6"
          component="h2"
          sx={{
            textTransform: 'uppercase',
          }}
        >
          Reallocate
        </Typography>
        <IconButton
          onClick={() => setIsReallocateModalOpen(false)}
          sx={{
            color: '#fff',
            position: 'absolute',
            top: 0,
            right: 0,
          }}
        >
          <ClearIcon />
        </IconButton>
      </Box>
      <Box
        component="hr"
        sx={(theme) => ({
          width: '80%',
          height: '2px',
          backgroundColor: theme.palette.primary.main,
        })}
      />
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '5px',
        }}
      >
        {selectedJob?.vehicleDetails.displayName && (
          <Detail
            text={VehicleDisplayName({
              vehicleDetails: selectedJob?.vehicleDetails,
            })}
            showBorder={true}
          />
        )}
        {selectedJob?.driver?.vehicle?.makeAndModel && (
          <Detail
            text={selectedJob?.driver?.vehicle?.makeAndModel}
            showBorder={true}
          />
        )}
        {selectedJob?.status?.estimatedArrivalTime && (
          <Detail
            text={`Exp: ${getEstimatedArrivalTime(
              selectedJob?.status?.estimatedArrivalTime,
            )}`}
            showBorder={true}
          />
        )}
        {selectedJob?.supplier.companyName && (
          <Detail text={selectedJob?.supplier.companyName} showBorder={true} />
        )}
        {selectedJob?.estimatedPrice?.price && (
          <Detail
            text={DisplayPrice({
              VATTotalPrice: selectedJob?.estimatedPrice,
              priceType: fixedPriceDisplay ? 'exact' : 'range',
              displayVATPrice: displayVATPrice,
            })}
          />
        )}
        <Box
          component="img"
          src={selectedJob?.vehicleDetails.icon}
          style={{ maxHeight: '30px', width: 'auto' }}
        />
      </Box>
    </Box>
  )
}

export default Header
